<template>
    <div>
      <v-toolbar flat color="orange darken-3">
        <v-spacer></v-spacer>
        <v-toolbar-title class="white--text" >
          My Account
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <div v-if="account_id > 0">
        <v-row justify="center" align="center" class="text-center">
          <v-col cols="12" sm="12" md="12">
            <h2>{{ $t('welcome',{ user_name: user_name }) }}</h2>
          </v-col>
        </v-row>
        <!-- Código referido -->
        <v-row justify="center" align="center">
        <!-- Columna para el texto -->
        <v-col cols="12" sm="8" md="6">
          <p>{{ $t('referral_code') }}: <strong>{{ reference }}</strong></p>
        </v-col>
        <!-- Columna para el ícono -->
        <v-col cols="12" sm="4" md="2" class="d-flex align-center">
          <v-icon
            color="primary"
            outlined
            @click="copiarCodigo"
            class="cursor-pointer"
          >
            mdi-content-copy
          </v-icon>
        </v-col>
      </v-row>
      </div>
      <div v-if="credit > 0">
        <!-- Código referido -->
        <v-row class="mx-auto">
        <!-- Columna para el texto -->
        <v-col cols="12" sm="8" md="6">
          <p>Credits: <strong>{{ toPrice(credit) }}</strong></p>
        </v-col>
      </v-row>
      </div>
      <v-list dense>
      <v-list-item
        v-for="(item, index) in filteredItems"
        :key="index"
        @click="goAction(item.action)"
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
    >
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
	<LoginRegister
		:show="showDialoLoginRegister"
		:reference="reference"
		@close="showDialoLoginRegister=false"
		@emit_registrar="Registro"
		@emit_login="Login"
	/>
    </div>
</template>
<script>
import LoginRegister from "@/components/dialog/dialogRegisterLogin.vue";
export default {
    props:[
      'account_id',
      'group_id',
      'currentLocale',
      'reference',
      'user_name',
      'credit',
    ],
    components: {
		LoginRegister
	},
    data: () => ({
      header:[],
	    showDialoLoginRegister:false,
      items: [
        { title: 'Register / Login', action: 'showLoginRegister', min_group: null, need_login: false, icon: 'mdi-home', route: '/' },
        { title: 'My Account', action: 'MyAccount',min_group: 0, need_login: true, icon: 'mdi-account', route: '/myaccount' },
        { title: 'My Characters',action: 'MyCharacters', min_group: 0, need_login: true, icon: 'mdi-account-multiple', route: '/mycharacters' },
        { title: 'Vote4Point', action: 'Vote4Point',min_group: 0, need_login: true, icon: 'mdi-vote', route: '/vote4point' }, // corregí "metwork" por "network"
        { title: 'ACP', action: 'ACP',min_group: 99, need_login: true, icon: 'mdi-account-group', route: '/acp' }, // corregí "metwork" por "network"
        { title: 'Logout', action: 'Logout',min_group: 0, need_login: true, icon: 'mdi-account-group', route: '/network' }, // corregí "metwork" por "network"
      ],
      filteredItems: [],
      snackbar: false,
      text: 'Reference link copied',
      timeout: 1200,
    }),
    computed: {
    },
    mounted() {
      this.filteredItems = this.getFilteredItems();
    },
    methods: {
      goAction(value){
        switch(value){
          case 'showLoginRegister': this.showDialoLoginRegister = true; break;
          case 'MyAccount': this.$router.push('/myaccount'); break;
          case 'MyCharacters': this.$router.push('/mycharacters'); break;
          case 'Vote4Point': this.$router.push('/vote'); break;
          case 'ACP': this.$router.push('/acp'); break;
          case 'Logout': this.Desconectarse(); break;
        }
      },
      Desconectarse(){
        this.$emit('logout');
      },
      Registro(value){
        this.showDialoLoginRegister = false;
        this.$emit('emit_registrar',value);
      },
      Login(value){
        this.showDialoLoginRegister = false;
        this.$emit('emit_login',value);
      },
      copiarCodigo() {
        let dominioActual = window.location.origin;
        dominioActual += "/ref/"+this.reference;
        navigator.clipboard.writeText(dominioActual).then(() => {
        this.snackbar = true;
      });
      },
      getFilteredItems() {
        return this.items.filter(item => {
          if (!item.need_login && (!this.account_id || this.account_id === 0)) {
            return true;
          }
          // Renderizar si no se necesita login
          if (item.need_login && (!this.account_id || this.account_id === 0)) {
            return false;
          }
          // Renderizar si se necesita login y el usuario está logueado
          if (item.need_login && this.account_id > 0 && item.min_group <= this.group_id) {
            return true;
          }
          // No renderizar en cualquier otro caso
          return false;
        });
      },
    },
    watch: {
      account_id(){
        this.filteredItems = this.getFilteredItems();
      },
    },
};
</script>